module.exports = "<button class=\"button\" (click)=\"openSidenavMobile()\" mat-icon-button fxHide.gt-md>\r\n  <mat-icon>menu</mat-icon>\r\n</button>\r\n"